var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandLogomark = function SvgBrandLogomark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF2C",
    d: "M20.034 9.981C20.034 7.244 20 0 20 0h10.01a9.98 9.98 0 0 1 9.232 6.177 10.01 10.01 0 0 1-2.174 10.9 9.99 9.99 0 0 1-10.894 2.156 9.99 9.99 0 0 1-6.155-9.252z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m30 25.19-6.464-9.545a20.7 20.7 0 0 1-3.564-11.62V.02A.02.02 0 0 0 19.95 0 20.06 20.06 0 0 0 6.198 5.57 20.1 20.1 0 0 0 .022 19.076C-.512 30.576 8.835 40 20.335 40h19.657l.006-.007.002-.008-.002-.008-.006-.007z"
  })));
};
export default SvgBrandLogomark;